export const ACCEPTED_IMAGE_TYPES = ['image/jpeg', 'image/jpg']

export const ACCEPTED_IMAGE_EXTENSIONS = '.jpg,.jpeg'

export const MAX_FILE_SIZE_BYTES = 8 * 1024 * 1024

/** Image side slots supported by the catalogue service. Slot 89 is reserved for the hero image. */
export const MIN_IMAGE_SIDE = 1
export const MAX_IMAGE_SIDE = 88

/** Side name for the back-office hero image: upload as {sku}_hero.jpg, delete with side "hero". Stored as slot 89. */
export const HERO_IMAGE_SIDE = 'hero'

export const PRODUCT_MEDIA_FILENAME_PATTERN =
  /^(\d+)_([1-9]|[1-7]\d|8[0-8]|hero)\.jpe?g$/i

export const MEDIA_UPLOAD_API_URL = '/gt-catelogue/v1/media'

export const MEDIA_UPLOAD_BATCH_SIZE = 10

/** Max automatic re-upload attempts per file after a retryable failure. */
export const MEDIA_UPLOAD_MAX_RETRY_ATTEMPTS = 3
/** Multipart field name for delete-by-CSV requests (preview and delete). */
export const BULK_DELETE_UPLOAD_FIELD = 'uploadfile'

/**
 * Catalogue Service V2 – delete product images by CSV (multipart field: uploadfile).
 * - Preprod:  https://api.internal.preprod.fairprice.com.sg/bg/optimus/catalogue-service/v1/media/product-images/delete
 * - Production: https://api.internal.fairprice.com.sg/bg/optimus/catalogue-service/v1/media/product-images/delete
 */
export const MEDIA_BULK_DELETE_API_URL =
  '/gt-catelogue/v1/media/product-images/delete'

/**
 * Dry-run preview before delete (same uploadfile body as delete).
 * - Preprod:  .../v1/media/product-images/delete/preview
 */
export const MEDIA_BULK_DELETE_PREVIEW_API_URL =
  '/gt-catelogue/v1/media/product-images/delete/preview'

/** Max rows allowed in one bulk delete CSV. */
export const BULK_DELETE_MAX_RECORDS = 500

/** Max rows shown in the preview table (API may return more). */
export const BULK_DELETE_PREVIEW_DISPLAY_LIMIT = 100

export const BULK_DELETE_CSV_SKU_HEADER = 'sku'

export const BULK_DELETE_CSV_SIDE_HEADERS = ['side', 'image_side_code']

export const SAMPLE_BULK_DELETE_CSV =
  'data:text/csv;charset=utf-8,sku,side%0A10000661,2%0A13058255,12%0A13058255,25%0A'

/**
 * Catalogue Service V2 – query product image audit logs (POST JSON body).
 * - Preprod:  .../v1/media/query
 */
export const MEDIA_AUDIT_LOGS_QUERY_API_URL = '/gt-catelogue/v1/media/query'

export const MEDIA_AUDIT_LOG_TYPE = 'PRODUCT_IMAGE'

export const MEDIA_AUDIT_LOG_STATUSES = [
  'PENDING',
  'PROCESSING',
  'PASS',
  'FAIL',
]

export const MEDIA_AUDIT_LOG_ACTIONS = ['UPLOAD', 'DELETE']

export const MEDIA_AUDIT_LOGS_PAGE_SIZE = 100
